import { useEffect, useLayoutEffect, useRef, useState } from "react";

import { useFeder } from "../../lib/spring";

export type Segment = { id: string; label: string };

/**
 * Segmentsteuerung: die Markierung gleitet per Feder zum gewählten Segment.
 * Wird während der Bewegung erneut gewechselt, biegt sie ab, statt zu springen.
 */
export function Segmente({ segmente, wert, onChange }: { segmente: Segment[]; wert: string; onChange: (id: string) => void }) {
  const leiste = useRef<HTMLDivElement>(null);
  const [mass, setMass] = useState({ x: 0, breite: 0 });
  const [bereit, setBereit] = useState(false);

  const messe = () => {
    const el = leiste.current?.querySelector<HTMLButtonElement>(`[data-id="${wert}"]`);
    const eltern = leiste.current;
    if (!el || !eltern) return;
    setMass({ x: el.offsetLeft - eltern.clientLeft, breite: el.offsetWidth });
  };
  useLayoutEffect(messe, [wert, segmente]);
  useEffect(() => {
    const ro = new ResizeObserver(messe);
    if (leiste.current) ro.observe(leiste.current);
    setBereit(true);
    return () => ro.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const x = useFeder(mass.x, { response: 0.3, damping: 1 });
  const breite = useFeder(mass.breite, { response: 0.3, damping: 1 });

  return (
    <div className="kalk-segmente" role="tablist" ref={leiste}>
      {bereit && mass.breite > 0 && (
        <span className="kalk-segmente__marke" aria-hidden="true" style={{ transform: `translateX(${x}px)`, width: breite }} />
      )}
      {segmente.map((s) => (
        <button
          key={s.id}
          type="button"
          role="tab"
          data-id={s.id}
          aria-selected={s.id === wert}
          className={`kalk-segment${s.id === wert ? " kalk-segment--aktiv" : ""}`}
          onPointerDown={() => onChange(s.id)}
          onClick={() => onChange(s.id)}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
